import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CATEGORY_PARAM, withCategory } from '../utils/categoryParam';

/**
 * Selected category, stored in the URL instead of component state.
 *
 * Home and catalog screens remount when the customer opens a product and
 * presses Back; local state reset to "All" on that remount, dropping them back
 * at the start instead of the category they were browsing. Keeping it in the
 * URL lets the Back navigation restore it, and makes the view linkable.
 *
 * Selecting a category replaces the current history entry rather than pushing
 * one, so Back still leaves the screen in a single step instead of stepping
 * through every tab the customer tapped.
 */
export const useCategoryParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selected = searchParams.get(CATEGORY_PARAM) || null;
  const setSelected = useCallback(
    (categoryId) => setSearchParams((prev) => withCategory(prev, categoryId), { replace: true }),
    [setSearchParams]
  );
  return [selected, setSelected];
};

export default useCategoryParam;
